import React from 'react';
import { useEffect, useState } from 'react';
import { decode } from 'base-64';
import { getFresherDocuments, getExpDocuments, postFresherDocuments, postExpDocuments, postDocStatus } from '../service/RecruiterApi';
import moment from 'moment';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import { getS3 } from '../utils/Download.js';

function CandidateDocumentDetails(props) {
    const id = props.candidate_id;

    const [documentData, setDocumentData] = useState([]);
    const [documentId, setDocumentId] = useState('');
    const [comments, setComments] = useState('');
    const [renderFlag, setRenderFlag] = useState(false);
    const [validation, setValidation] = useState('');
    const [popup, setPopup] = useState(false);
    useEffect(() => {
        getData();
    }, [renderFlag]);

    let getData = async () => {
        try {
            let resp;
            if (props.experience == 'Fresher') {
                resp = await getFresherDocuments({ id: id });
            } else if (props.experience == 'Experienced') {
                resp = await getExpDocuments({ id: id });
            }

            setDocumentData(resp.data.data);
        } catch (e) {}
    };

    let Validation = () => {
        if (comments == '') {
            setValidation('Reason is required');
            return false;
        } else {
            let checkregex = OnlyNumberSpecialChar(comments);
            if (checkregex) {
                setValidation('Valid Reason is required');
                return false;
            } else {
                return true;
            }
        }
    };


    // function signedURL(urls, expired_in = "") {
    //     try {
    //         // Extract the path portion from the URL
    //         const path = new URL(urls).pathname;

    //         // Remove leading slash if present
    //         const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

    //         // Decode URI components to handle special characters
    //         const decodedPath = decodeURIComponent(cleanedPath);

    //         const modifiedString = removeFirstAndLastThree('');

    //         // Decoding the encoded string
    //         const decodedStringaccessKey = decode(modifiedString);

    //         function removeFirstAndLastThree(str) {
    //             return str.slice(3, -3);
    //         }
    //         const modifiedString1 = removeFirstAndLastThree('')
    //         const decodedStringaccessKeyID = decode(modifiedString1);

    //         const accessKeyId = decodedStringaccessKey;
    //         const secretAccessKey = decodedStringaccessKeyID;
    //         const region = process.env.REACT_APP_REGION;
    //         const bucketName =  "";

    //         const s3 = new S3({
    //             accessKeyId,
    //             secretAccessKey,
    //             region,
    //         });



    //         // Generate a pre-signed URL for downloading the object
    //         let params = {
    //             Bucket: bucketName,
    //             Key: decodedPath,
    //             Expires: expired_in ? "" : 3600, // URL will expire in 0.5 hour
    //         };


    //         const finalURL = s3.getSignedUrl('getObject', params);


    //         return finalURL;
    //     }
    //     catch (error) {
    //         throw error;
    //     }
    // }


    let documentClick = async (value, docId) => {
        if (value == 'Rejected') {
            if (Validation() == true) {
                // let docuId = documentId;
                let resp;

                setDocumentId(docId);

                if (props.experience == 'Fresher') {
                    resp = await postFresherDocuments({
                        id: docId,
                        value: value,
                        comment: comments,
                    });
                    let values = await postDocStatus({
                        exp: 'Fresher',
                        doc_verify: 'Rejected',
                        candidate_id: id,
                    });
                } else if (props.experience == 'Experienced') {
                    resp = await postExpDocuments({
                        id: docId,
                        value: value,
                        comment: comments,
                    });
                    let values = await postDocStatus({
                        exp: 'exp',
                        doc_verify: 'Rejected',
                        candidate_id: id,
                    });
                }

                setDocumentId('');
                setComments('');
                setPopup(false);
                setRenderFlag(!renderFlag);
            }
        } else {
            let resp;

            setDocumentId(docId);

            if (props.experience == 'Fresher') {
                resp = await postFresherDocuments({
                    id: docId,
                    value: value,
                    comment: comments,
                });
                let arr = [];
                let newarr = [];
                if (props.experience == 'Fresher') {
                    resp = await getFresherDocuments({ id: id });
                }
                for (let i = 0; i < resp.data.data.length; i++) {
                    arr.push(resp.data.data[i].status);
                }

                arr.filter((param) => {
                    if (param == 'Approved') {
                        newarr.push('approved');
                    }
                });

                if (arr.length === newarr.length) {
                    let values = await postDocStatus({
                        exp: 'Fresher',
                        doc_verify: 'Approved',
                        candidate_id: id,
                    });
                }
            } else if (props.experience == 'Experienced') {
                resp = await postExpDocuments({
                    id: docId,
                    value: value,
                    comment: comments,
                });
                let arr = [];
                let newarr = [];
                if (props.experience == 'Experienced') {
                    resp = await getExpDocuments({ id: id });
                }
                for (let i = 0; i < resp.data.data.length; i++) {
                    arr.push(resp.data.data[i].status);
                }

                arr.filter((param) => {
                    if (param == 'Approved') {
                        newarr.push('approved');
                    }
                });

                if (arr.length === newarr.length) {
                    let values = await postDocStatus({
                        exp: 'exp',
                        doc_verify: 'Approved',
                        candidate_id: id,
                    });
                }
            }

            setDocumentId('');
            setComments('');
            setPopup(false);
            setRenderFlag(!renderFlag);
        }
    };

    let bindDocuments = () => {
        try {
            if (documentData?.length == 0) {
                return (
                    <div>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/nodatafound.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            ></img>
                            <h2 className="semibold-text font-25 text-center margin-negative">No Documents Found!</h2>
                        </div>
                    </div>
                );
            } else {
                return documentData.map((obj, index) => {
                    return (
                        <ul key={index} className="list-unstyled align-middle">
                            <li className="bg-white touchbase-tile mt-3">
                                <ul className="d-flex justify-content-between custom-structure">
                                    <li className="semibold-text font-14">{obj.documents}</li>
                                    <li className="align-items-center">
                                        <a
                                                href="#"
                                                style={{cursor:"pointer"}} onClick={async (e) => {
                                                    e.preventDefault();
                                                    window.open(await getS3(obj?.doc_url, "1"), "_blank");
            
            
                                                }} 
                                                // onClick={(e) => {
                                                //     e.preventDefault();
                                                //     const url = getS3(obj?.doc_url, "1");
                                                //     window.open(url, '_blank');
                                                // }}
                                                className="d-block font-13 color-darkblue bold-text text-decoration-none"
                                            >
                                                {obj?.doc_url?.split('/').pop()}
                                            </a>
                                    </li>
                                    <li className="regular-text font-14">{moment(obj.modified_at).format('ll')}</li>
                                    {obj.status == null || obj.status == '' ? (
                                        <li className="d-flex">
                                            <button
                                                className="document-red-btn"
                                                data-bs-toggle="modal"
                                                data-bs-target="#reject"
                                                onClick={() => {
                                                    setDocumentId(obj.id);
                                                    setPopup(true);
                                                }}
                                            >
                                                Reject
                                            </button>
                                            <button
                                                className="document-green-btn"
                                                onClick={() => {
                                                    setDocumentId(obj.doc_id);
                                                    documentClick('Approved', obj.id);
                                                }}
                                            >
                                                Approve
                                            </button>
                                        </li>
                                    ) : obj.status == 'Approved' ? (
                                        <button disabled className="document-green-btn me-5 font-13">
                                            Approved
                                        </button>
                                    ) : (
                                        <button
                                            disabled
                                            className="document-red-btn me-5 font-14"
                                            data-bs-toggle="modal"
                                            data-bs-target="#reject"
                                        >
                                            Rejected
                                        </button>
                                    )}
                                </ul>
                            </li>
                        </ul>
                    );
                });
            }
        } catch (e) {}
    };

    return (
        <div>
            <div>{bindDocuments()}</div>

            {popup == true ? (
                <div>
                    <div
                        className="modal fade show"
                        style={{ display: 'block' }}
                        id="reject"
                        tabIndex={-1}
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-position">
                            <div className="modal-content border-none">
                                <div className="row">
                                    <h1 className="bold-text col-md-10 font-16 ps-4 pt-4">Reason for Rejection</h1>
                                    <button
                                        type="button"
                                        className="btn-close text-reset pt-5 ps-4 ms-4 mb-0"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => {
                                            setComments('');
                                            setDocumentId('');
                                            setDocumentId('');

                                            setPopup(false);
                                            setRenderFlag(!renderFlag);
                                        }}
                                    />
                                    <div className="col-md-12 float-start px-4 pb-3">
                                        <label className="form-label regular-text recruit-summary-label pb-2">
                                            Comments<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <textarea
                                            className="form-control custom-comment-box custom-textfield"
                                            value={comments}
                                            maxLength={255}
                                            onChange={(e) => {
                                                setComments(e.target.value);
                                                setValidation('');
                                            }}
                                            placeholder="Enter Comments"
                                        ></textarea>
                                        <span style={{ color: 'red' }}>{validation}</span>
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <button
                                                type="button"
                                                className="btn hive-btn-secondary"
                                                data-bs-dismiss="modal"
                                                onClick={() => {
                                                    setComments('');
                                                    setDocumentId('');
                                                    setDocumentId('');

                                                    setPopup(false);
                                                    setRenderFlag(!renderFlag);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn hive-btn-primary"
                                                //data-bs-dismiss="modal"
                                                onClick={() => {
                                                    documentClick('Rejected', documentId);
                                                }}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default CandidateDocumentDetails;
